module.exports = __webpack_public_path__ + "static/media/iw-logo.6ea4af7f.svg";